// @ts-ignore
import variables from 'styles/_variables.scss';

interface ITrendPercents {
	promotersPercent: number | undefined;
	passivePercent: number | undefined;
	detractorsPercent: number | undefined;
}

export const getScore = (percent: number | undefined, defaultScore: string) =>
	percent !== undefined ? `${Math.round(percent)}%` : defaultScore;

export const getMaxProgress = ({
	promotersPercent,
	passivePercent,
	detractorsPercent,
}: ITrendPercents) => {
	if (
		promotersPercent === undefined &&
		passivePercent === undefined &&
		detractorsPercent === undefined
	)
		return undefined;

	return Math.max(
		promotersPercent || 0,
		passivePercent || 0,
		detractorsPercent || 0,
	);
};

export const calculateProgressPercentage = (
	score: number | undefined,
	maxProgress: number | undefined,
) => {
	if (maxProgress === undefined) return 100;
	if (score === undefined) return 0;
	return score === maxProgress ? 100 : (score / maxProgress) * 100;
};

export const getBarColor = (
	baseColor: string,
	maxProgress: number | undefined,
) => {
	return maxProgress === undefined ? variables.lightBackgroundColor : baseColor;
};
